import { cloneDeep } from 'lodash'

import { Mixpanel, MIXPANEL_PROPS } from 'utils/mixpanel'

import {
  getUnblockCount,
  isPaidUser,
  KEYWORD_LISTS,
} from '../../utils/freeVersionBlock'
import { sortData } from '../../utils/functions'

import {
  ADD_KEYWORD_LIST,
  CHANGE_SORT,
  DELETE_KEYWORD_LIST,
  FETCH_KEYWORD_LISTS,
  GET_KEYWORD_LIST_DATA,
  GET_KEYWORD_LOCATIONS,
  UPDATE_KEYWORD_LIST,
} from './actions'

const initialState = {
  lists: null,
  isLoadingKeywordLists: false,
  currentSort: '',
  sortAsc: true,
  isLoadingKeywords: false,
  currentList: null,
  isLoadingKeywordLocations: false,
}

const getSortData = (state, sort, handleNumeric = false) => {
  const { currentSort, sortAsc } = state
  const currentSortASC = currentSort === sort ? !sortAsc : true

  Mixpanel.trackSortClick({
    sortedColumn: MIXPANEL_PROPS.SORTED_COLUMN.values[sort.toUpperCase()],
    sortedType: currentSortASC
      ? MIXPANEL_PROPS.SORTED_TYPE.values.ASCENDING
      : MIXPANEL_PROPS.SORTED_TYPE.values.DESCENDING,
  })
  if (isPaidUser()) {
    if (state.currentSort === sort) {
      const sorted = sortData(state.lists, sort, !state.sortAsc, handleNumeric)
      return {
        sortAsc: !state.sortAsc,
        lists: cloneDeep(sorted),
      }
    }
    const sorted = sortData(state.lists, sort, state.sortAsc, handleNumeric)
    return {
      currentSort: sort,
      lists: cloneDeep(sorted),
    }
  }
  const unBlockedCount = getUnblockCount(
    KEYWORD_LISTS,
    'results',
    state.lists.length,
  )
  const unBlockedData = state.lists.slice(0, unBlockedCount)
  const blockedData = state.lists.slice(unBlockedCount)

  if (state.currentSort === sort) {
    const sorted = sortData(unBlockedData, sort, !state.sortAsc, handleNumeric)
    return {
      sortAsc: !state.sortAsc,
      lists: cloneDeep(sorted).concat(blockedData),
    }
  }
  const sorted = sortData(unBlockedData, sort, state.sortAsc, handleNumeric)
  return {
    currentSort: sort,
    filteredVersion: state.filteredVersion + 1,
    lists: cloneDeep(sorted).concat(blockedData),
  }
}

const keywordListsReducer = (state, action) => {
  state = state || initialState
  let resultState = null
  switch (action.type) {
    case FETCH_KEYWORD_LISTS.action:
      resultState = {
        ...state,
        isLoadingKeywordLists: true,
      }
      break
    case FETCH_KEYWORD_LISTS.success:
      resultState = {
        ...state,
        ...action.payload,
        isLoadingKeywordLists: false,
      }
      break
    case FETCH_KEYWORD_LISTS.failed:
      resultState = {
        ...state,
        lists: [],
        isLoadingKeywordLists: false,
      }
      break
    case ADD_KEYWORD_LIST.success:
    case DELETE_KEYWORD_LIST.success:
    case UPDATE_KEYWORD_LIST.success:
      resultState = {
        ...state,
        ...action.payload,
      }
      break
    case GET_KEYWORD_LIST_DATA.action:
      resultState = {
        ...state,
        isLoadingKeywords: true,
      }
      break
    case GET_KEYWORD_LIST_DATA.success:
      resultState = {
        ...state,
        currentList: {
          ...action.payload,
          keywords: sortData(action.payload.keywords, 'keyword', true, false),
        },
        isLoadingKeywords: false,
      }
      break
    case GET_KEYWORD_LIST_DATA.failed:
      resultState = {
        ...state,
        currentList: null,
        isLoadingKeywords: false,
      }
      break
    case CHANGE_SORT.action:
      resultState = {
        ...state,
        ...getSortData(state, action.sort, action.handleNumeric),
      }
      break
    case GET_KEYWORD_LOCATIONS.action:
      resultState = {
        ...state,
        isLoadingKeywordLocations: true,
      }
      break
    case GET_KEYWORD_LOCATIONS.success:
      resultState = {
        ...state,
        isLoadingKeywordLocations: false,
      }
      break
    default:
      return state
  }

  if (!resultState) {
    resultState = {
      ...state,
    }
  }
  return resultState
}

export default keywordListsReducer
